module.exports = __webpack_public_path__ + "img/forgot-password-v2-dark.c80eb06c.svg";